<ng-container>
    <div class="p-2">
        <div class="w-100">
            <ppl-timesheet-filter [filterFields]="fields" (searchEvent)="onSearch($event)"></ppl-timesheet-filter>
        </div>
        <div class="table-style">
            <ppl-list-table [sharedDataKey]="sharedDataKey" [loadPage]="true" [from]="'natpaylist'" [rowsToDisplay]="20"
                [columnsToBeHidden]="columnsToBeHidden" [enableActions]="false" [pagination]="true"
                [actionsToBeHidden]="actionsToBeHidden" [customDataLoaded]="true" [cols]="paylistdetailsCols"
                rowDataAccessibilityKey="fileName" [data]="paylistdetails" [gridTitle]="false" [disableSearch]="true"
                [showCustomSearch]="false" (onPageLoad)="onPageLoad($event)" />
        </div>
    </div>
</ng-container>